import { formatStockQuantity } from "@/common/stock/stockNumberFormat";

const QUANTITY_EPSILON = 0.0001;

export default {
  methods: {
    statusColor(status) {
      const map = {
        draft: "grey",
        finalized: "success",
        cancelled: "error",
      };
      return map[status] || "grey";
    },
    statusLabel(status) {
      const key = `STOCK.REVISIONS.STATUSES.${(status || "").toUpperCase()}`;
      return this.$te(key) ? this.$t(key) : status || "-";
    },
    warehouseLabel(row) {
      const warehouse = row && row.warehouse;
      if (!warehouse) {
        return "-";
      }
      if (warehouse.code && warehouse.name) {
        return `${warehouse.code} — ${warehouse.name}`;
      }
      return warehouse.name || warehouse.code || "-";
    },
    organizationLabel(row) {
      const organization = row && row.organization;
      if (!organization) {
        return "-";
      }
      return organization.name || organization.code || "-";
    },
    formatQuantity(value) {
      if (value == null || value === "") {
        return "-";
      }
      return formatStockQuantity(value);
    },
    formatSignedQuantity(value) {
      if (value == null || value === "") {
        return "-";
      }
      const amount = Number(value);
      const prefix = amount > QUANTITY_EPSILON ? "+" : "";
      return `${prefix}${formatStockQuantity(amount)}`;
    },
    formatMoney(value, currency) {
      if (value == null || value === "") {
        return "-";
      }
      return `${Number(value).toFixed(2)} ${currency || ""}`.trim();
    },
    formatSignedMoney(value, currency) {
      if (value == null || value === "") {
        return "-";
      }
      const amount = Number(value);
      const prefix = amount > 0 ? "+" : "";
      return `${prefix}${amount.toFixed(2)} ${currency || ""}`.trim();
    },
    varianceTextClass(value) {
      const amount = Number(value || 0);
      if (Math.abs(amount) <= QUANTITY_EPSILON) {
        return "";
      }
      return amount > 0 ? "success--text" : "error--text";
    },
    hasVariance(value) {
      return Math.abs(Number(value || 0)) > QUANTITY_EPSILON;
    },
    productLabel(row) {
      const product = (row && row.product) || null;
      if (!product) {
        return "-";
      }
      return product.display_name || product.code || "-";
    },
    productTags(row) {
      const product = (row && row.product) || null;
      if (!product || !Array.isArray(product.tags)) {
        return [];
      }
      return product.tags;
    },
    productTemperature(row) {
      const temperature = row && row.product && row.product.temperature;
      return (temperature && temperature.name) || "-";
    },
    productCategoryLabel(row) {
      const category = row && row.product && row.product.category;
      return (category && category.name) || "-";
    },
    productDepartmentLabel(row) {
      const category = row && row.product && row.product.category;
      const department = category && category.department;
      return (department && department.name) || "-";
    },
    productOriginLabel(row) {
      const origin = row && row.product && row.product.origin_country;
      return (origin && origin.name) || "-";
    },
    productUnitCode(row) {
      const unit = row && row.product && row.product.primary_unit;
      return (unit && unit.code) || "";
    },
  },
};
